import { NavLink } from 'react-router-dom'
import { 
  Home, 
  User, 
  Users, 
  MessageCircle,
  Settings,
  Info
} from 'lucide-react'
import { NavigationItem } from '@/types'

const navigationItems: NavigationItem[] = [
  {
    id: 'home',
    label: 'Dashboard',
    icon: 'Home',
    path: '/',
  },
  {
    id: 'avatar',
    label: 'Avatar',
    icon: 'User',
    path: '/avatar',
  },
  {
    id: 'connections',
    label: 'Connections',
    icon: 'Users',
    path: '/connections',
  },
  {
    id: 'chat',
    label: 'Messages',
    icon: 'MessageCircle',
    path: '/chat',
  },
]

const iconMap = {
  Home,
  User,
  Users,
  MessageCircle,
  Settings,
  Info,
}

export function Sidebar() {
  return (
    <div className="flex flex-col bg-white md:border-r md:border-secondary-200 shadow-soft">
      {/* Logo */}
      <div className="flex items-center h-16 px-6 border-b border-secondary-200">
        <div className="flex items-center">
          <div className="flex items-center justify-center w-8 h-8 bg-primary-600 rounded-lg">
            <span className="text-white font-bold text-sm">S</span>
          </div>
          <span className="ml-3 text-lg font-semibold text-secondary-900">
            useSelft
          </span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 py-6 space-y-2">
        {navigationItems.map((item) => {
          const IconComponent = iconMap[item.icon as keyof typeof iconMap]
          
          return (
            <NavLink
              key={item.id}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center px-3 py-2 rounded-lg transition-colors mobile-safe-area ${
                  isActive
                    ? 'bg-primary-50 text-primary-700 border-l-0 lg:border-l-4 lg:border-primary-600'
                    : 'text-secondary-600 hover:bg-secondary-50 hover:text-secondary-900'
                }`
              }
            >
              <IconComponent className="h-5 w-5 mr-3" />
              <span className="text-sm font-medium">{item.label}</span>
            </NavLink>
          )
        })}
      </nav>

      {/* Footer */}
      <div className="px-4 py-4 border-t border-secondary-200">
        <div className="text-xs text-secondary-500 text-center">
          <div className="mb-1">useSelft Standalone</div>
          <div>Version 1.0.0</div>
        </div>
      </div>
    </div>
  )
}